module.exports = __webpack_public_path__ + "img/usa_flag.753eb628.png";